import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-gradient-to-br dark:from-[#0c1427] dark:to-[#1a2332]" }
const _hoisted_2 = { class: "px-4 sm:px-6 lg:px-8 pt-6 pb-8" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" }
const _hoisted_4 = { class: "bg-white dark:bg-white/10 backdrop-blur-[10px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10" }
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_6 = { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }
const _hoisted_7 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_8 = { class: "bg-white dark:bg-white/10 backdrop-blur-[10px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10" }
const _hoisted_9 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_10 = { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }
const _hoisted_11 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_12 = { class: "bg-white dark:bg-white/10 backdrop-blur-[10px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10" }
const _hoisted_13 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_14 = { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }
const _hoisted_15 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_16 = { class: "bg-white dark:bg-white/10 backdrop-blur-[10px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10" }
const _hoisted_17 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_18 = { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }
const _hoisted_19 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_20 = { class: "px-4 sm:px-6 lg:px-8 pb-8" }
const _hoisted_21 = { class: "bg-white dark:bg-white/10 backdrop-blur-[20px] shadow-[0_20px_40px_0_rgba(0,0,0,0.1)] rounded-3xl overflow-hidden border border-gray-100 dark:border-white/10" }
const _hoisted_22 = { class: "px-6 lg:px-8 py-6 border-b border-black/[0.06] dark:border-white/[0.06]" }
const _hoisted_23 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" }
const _hoisted_24 = { class: "flex items-center gap-3 w-full sm:w-auto" }
const _hoisted_25 = { class: "relative w-full sm:w-auto" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "text-[15px] font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_28 = {
  key: 0,
  class: "ml-1 px-2 py-0.5 text-xs font-semibold bg-blue-500 text-white rounded-full"
}
const _hoisted_29 = { class: "flex gap-3 w-full sm:w-auto" }
const _hoisted_30 = { class: "overflow-x-auto" }
const _hoisted_31 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_32 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_33 = { class: "text-lg font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_34 = { class: "text-sm mt-1 text-[#8e8e93] dark:text-gray-400" }
const _hoisted_35 = {
  key: 2,
  class: "w-full"
}
const _hoisted_36 = { style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"} }
const _hoisted_37 = {
  class: "px-3 py-4 text-left",
  style: {"width":"40px","max-width":"40px"}
}
const _hoisted_38 = { class: "flex items-center justify-center" }
const _hoisted_39 = { class: "px-3 py-4 text-center text-white font-medium text-sm tracking-wide" }
const _hoisted_40 = { class: "px-3 py-4 text-center text-white font-medium text-sm tracking-wide" }
const _hoisted_41 = { class: "px-3 py-4 text-center text-white font-medium text-sm tracking-wide" }
const _hoisted_42 = { class: "px-3 py-4 text-center text-white font-medium text-sm tracking-wide" }
const _hoisted_43 = { class: "px-3 py-4 text-center text-white font-medium text-sm tracking-wide" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "flex items-center justify-center" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "px-3 py-4 text-center" }
const _hoisted_48 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm" }
const _hoisted_49 = { class: "px-3 py-4 text-center" }
const _hoisted_50 = { class: "text-gray-600 dark:text-gray-100 text-sm" }
const _hoisted_51 = { class: "px-3 py-4 text-center" }
const _hoisted_52 = { class: "text-gray-600 dark:text-gray-100 text-sm" }
const _hoisted_53 = { class: "px-3 py-4 text-center" }
const _hoisted_54 = { class: "text-gray-600 dark:text-gray-100 text-sm" }
const _hoisted_55 = { class: "flex items-center justify-center gap-1" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "border-t border-white/30 dark:border-gray-600 bg-white/80 dark:bg-gray-700/50 backdrop-blur-md" }
const _hoisted_59 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_60 = { class: "relative transform transition-all duration-300 scale-100 max-h-[90vh] overflow-y-auto bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-2xl" }
const _hoisted_61 = { class: "flex justify-between items-start mb-6 pb-6 border-b border-gray-100 dark:border-gray-800" }
const _hoisted_62 = { class: "flex items-center gap-4" }
const _hoisted_63 = { class: "text-2xl font-bold bg-gradient-to-r from-[#667eea] to-[#764ba2] bg-clip-text text-transparent" }
const _hoisted_64 = { class: "text-sm text-[#8e8e93] dark:text-gray-400 mt-1" }
const _hoisted_65 = { class: "space-y-6" }
const _hoisted_66 = { class: "text-lg font-semibold mb-3 text-[#1d1d1f] dark:text-white" }
const _hoisted_67 = { class: "flex flex-wrap gap-2" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "text-lg font-semibold mb-3 text-[#1d1d1f] dark:text-white" }
const _hoisted_70 = { class: "flex flex-wrap gap-2" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "flex gap-3 mt-8" }
const _hoisted_73 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_74 = { class: "bg-white rounded-2xl shadow-2xl w-full max-w-2xl z-10 relative max-h-[90vh] overflow-hidden mt-[125px] sm:mt-0" }
const _hoisted_75 = {
  class: "p-6 border-b border-gray-200",
  style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"}
}
const _hoisted_76 = { class: "flex items-center justify-between" }
const _hoisted_77 = { class: "flex items-center gap-3" }
const _hoisted_78 = { class: "text-xl font-bold text-white" }
const _hoisted_79 = { class: "p-6 overflow-y-auto max-h-[calc(90vh-200px)] bg-white" }
const _hoisted_80 = { class: "space-y-5" }
const _hoisted_81 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_82 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_83 = ["placeholder"]
const _hoisted_84 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_85 = ["placeholder"]
const _hoisted_86 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_87 = { class: "relative" }
const _hoisted_88 = ["placeholder"]
const _hoisted_89 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_90 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_91 = ["placeholder"]
const _hoisted_92 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_93 = ["placeholder"]
const _hoisted_94 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_95 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_96 = { value: "" }
const _hoisted_97 = { value: "Website" }
const _hoisted_98 = { value: "Social Media" }
const _hoisted_99 = { value: "Email Campaign" }
const _hoisted_100 = { value: "Direct" }
const _hoisted_101 = { value: "Referral" }
const _hoisted_102 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_103 = { value: "" }
const _hoisted_104 = ["value"]
const _hoisted_105 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_106 = ["placeholder"]
const _hoisted_107 = { class: "border-t border-gray-200 bg-white p-6" }
const _hoisted_108 = { class: "flex justify-between gap-3" }
const _hoisted_109 = ["disabled"]
const _hoisted_110 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_111 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_112 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl w-full max-w-md z-10 relative overflow-hidden" }
const _hoisted_113 = { class: "bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] dark:from-[#DC2626] dark:to-[#E11D48] p-6" }
const _hoisted_114 = { class: "flex items-center justify-between" }
const _hoisted_115 = { class: "flex items-center gap-3" }
const _hoisted_116 = { class: "text-xl font-bold text-white" }
const _hoisted_117 = { class: "text-red-100" }
const _hoisted_118 = { class: "p-6" }
const _hoisted_119 = { class: "p-5 bg-gradient-to-br from-[#FEF2F2] to-[#FEE2E2] dark:from-[#1a0f0f] dark:to-[#2a1a1a] rounded-2xl border border-[#FF3B30]/10 mb-6" }
const _hoisted_120 = { class: "text-[#1a1a1a] dark:text-white font-medium" }
const _hoisted_121 = { class: "flex gap-3" }
const _hoisted_122 = ["disabled"]
const _hoisted_123 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_124 = {
  key: 1,
  class: "ri-delete-bin-line text-lg"
}
const _hoisted_125 = {
  key: 3,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_126 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl w-full max-w-4xl z-10 relative max-h-[90vh] overflow-hidden" }
const _hoisted_127 = { class: "bg-gradient-to-r from-[#007AFF] to-[#5856D6] dark:from-[#0056CC] dark:to-[#4338CA] p-6" }
const _hoisted_128 = { class: "flex items-center justify-between" }
const _hoisted_129 = { class: "flex items-center gap-3" }
const _hoisted_130 = { class: "text-2xl font-bold text-white" }
const _hoisted_131 = { class: "text-blue-100" }
const _hoisted_132 = { class: "p-6 overflow-y-auto max-h-[calc(90vh-160px)]" }
const _hoisted_133 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_134 = { class: "p-6 bg-gradient-to-br from-[#F0F7FF] to-[#E6F3FF] dark:from-[#0c1427] dark:to-[#1a2642] rounded-3xl border border-[#007AFF]/10" }
const _hoisted_135 = { class: "text-xl font-bold text-[#1a1a1a] dark:text-white mb-6 flex items-center" }
const _hoisted_136 = { class: "space-y-4" }
const _hoisted_137 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_138 = { class: "text-lg font-medium text-[#1a1a1a] dark:text-white" }
const _hoisted_139 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_140 = { class: "text-[#1a1a1a] dark:text-white break-words" }
const _hoisted_141 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_142 = { class: "text-[#1a1a1a] dark:text-white" }
const _hoisted_143 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_144 = { class: "p-6 bg-gradient-to-br from-[#F0F9F5] to-[#E6F7ED] dark:from-[#0a1a0f] dark:to-[#1a2e1a] rounded-3xl border border-[#34C759]/10" }
const _hoisted_145 = { class: "text-xl font-bold text-[#1a1a1a] dark:text-white mb-6 flex items-center" }
const _hoisted_146 = { class: "space-y-4" }
const _hoisted_147 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_148 = { class: "text-[#1a1a1a] dark:text-white" }
const _hoisted_149 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_150 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_151 = { class: "text-[#1a1a1a] dark:text-white" }
const _hoisted_152 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_153 = { class: "text-[#1a1a1a] dark:text-white" }
const _hoisted_154 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_155 = { class: "text-xl font-bold text-[#34C759]" }
const _hoisted_156 = { class: "text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-1" }
const _hoisted_157 = { class: "text-[#1a1a1a] dark:text-white" }
const _hoisted_158 = { class: "border-t border-[#E5E7EB] dark:border-[#374151] bg-[#F8F9FA] dark:bg-[#0c0c0c] p-6" }
const _hoisted_159 = { class: "flex justify-end" }
const _hoisted_160 = {
  key: 4,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_161 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl w-full max-w-4xl z-10 relative max-h-[90vh] overflow-hidden" }
const _hoisted_162 = { class: "bg-gradient-to-r from-[#007AFF] to-[#5856D6] dark:from-[#0056CC] dark:to-[#4338CA] p-6" }
const _hoisted_163 = { class: "flex items-center justify-between" }
const _hoisted_164 = { class: "flex items-center gap-3" }
const _hoisted_165 = { class: "text-2xl font-bold text-white" }
const _hoisted_166 = { class: "text-blue-100" }
const _hoisted_167 = { class: "p-6 overflow-y-auto max-h-[calc(90vh-160px)]" }
const _hoisted_168 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-8" }
const _hoisted_169 = { class: "p-6 bg-gradient-to-br from-[#F0F7FF] to-[#E6F3FF] dark:from-[#0c1427] dark:to-[#1a2642] rounded-3xl border border-[#007AFF]/10" }
const _hoisted_170 = { class: "text-xl font-bold text-[#1a1a1a] dark:text-white mb-6 flex items-center" }
const _hoisted_171 = { class: "space-y-4" }
const _hoisted_172 = { class: "p-6 bg-gradient-to-br from-[#F0F9F5] to-[#E6F7ED] dark:from-[#0a1a0f] dark:to-[#1a2e1a] rounded-3xl border border-[#34C759]/10" }
const _hoisted_173 = { class: "space-y-4" }
const _hoisted_174 = { class: "p-6 bg-gradient-to-br from-[#F8F0FF] to-[#F3E8FF] dark:from-[#1a0d1a] dark:to-[#2a1a2a] rounded-3xl border border-[#5856D6]/10" }
const _hoisted_175 = { class: "space-y-4" }
const _hoisted_176 = { class: "relative" }
const _hoisted_177 = { class: "p-6 bg-gradient-to-br from-[#FFF7E6] to-[#FEF3C7] dark:from-[#1a1406] dark:to-[#2a2306] rounded-3xl border border-[#FF9500]/10" }
const _hoisted_178 = { class: "text-xl font-bold text-[#1a1a1a] dark:text-white mb-6 flex items-center" }
const _hoisted_179 = { class: "space-y-4" }
const _hoisted_180 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_181 = { class: "border-t border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] p-6" }
const _hoisted_182 = { class: "flex justify-end gap-4" }
const _hoisted_183 = ["disabled"]
const _hoisted_184 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_185 = {
  key: 1,
  class: "ri-save-line text-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
              _createElementVNode("div", {
                class: "w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg",
                style: {"background":"linear-gradient(135deg, #10b981, #059669)"}
              }, [
                _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "trending_up")
              ])
            ], -1)),
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.directT('crm.customers.totalRevenue') || 'סך הכנסות'), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatCurrency(_ctx.totalRevenue)), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT('crm.customers.last30Days') || 'הימים האחרונים 30'), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[47] || (_cache[47] = _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
              _createElementVNode("div", {
                class: "w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg",
                style: {"background":"linear-gradient(135deg, #8b5cf6, #7c3aed)"}
              }, [
                _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "group_add")
              ])
            ], -1)),
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.directT('crm.customers.newCustomers') || 'לקוחות חדשים'), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.newCustomersCount), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.directT('crm.customers.last30Days') || 'הימים האחרונים 30'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
              _createElementVNode("div", {
                class: "w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg",
                style: {"background":"linear-gradient(135deg, #3b82f6, #1d4ed8)"}
              }, [
                _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "groups")
              ])
            ], -1)),
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.directT('crm.customers.activeCustomers') || 'לקוחות פעילים'), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.activeCustomersCount), 1),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.directT('crm.customers.last30Days') || 'הימים האחרונים 30'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
              _createElementVNode("div", {
                class: "w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg",
                style: {"background":"linear-gradient(135deg, #f97316, #ea580c)"}
              }, [
                _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "groups")
              ])
            ], -1)),
            _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.directT('crm.customers.totalCustomers') || 'סך הלקוחות'), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.totalCustomers), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.directT('crm.customers.allTime') || 'כל הזמנים'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-[#8e8e93]" }, "search")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: _ctx.directT('crm.customers.searchByNameOrEmail') || 'חיפוש לקוחות...',
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
                    class: "bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 pl-11 pr-4 h-11 text-[15px] rounded-full w-full sm:w-[320px] text-black dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-blue-500/30 transition-all shadow-md hover:shadow-lg focus:shadow-xl"
                  }, null, 40, _hoisted_26), [
                    [_vModelText, _ctx.searchQuery]
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterModal = true)),
                  class: _normalizeClass(["h-11 px-5 rounded-full bg-white dark:bg-white/10 border border-gray-200 dark:border-white/10 flex items-center gap-2 hover:shadow-lg transition-all shadow-md", { 'ring-2 ring-blue-500': _ctx.hasActiveFilters }])
                }, [
                  _cache[51] || (_cache[51] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-[#8e8e93] dark:text-gray-400" }, "filter_list", -1)),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.directT('crm.customers.filter') || 'סנן'), 1),
                  (_ctx.activeFilterCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.activeFilterCount), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.selectedCustomers.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showBulkAssignModal && _ctx.showBulkAssignModal(...args))),
                      style: {"background":"#007AFF","color":"white","padding":"12px 20px","font-size":"15px","font-weight":"500"},
                      class: "rounded-full flex items-center gap-2 hover:opacity-90 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
                    }, [
                      _cache[52] || (_cache[52] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "person_add", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.directT('crm.customers.assignTo') || 'הקצה ל') + " (" + _toDisplayString(_ctx.selectedCustomers.length) + ")", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addNewCustomer && _ctx.addNewCustomer(...args))),
                  style: {"background":"linear-gradient(135deg, #667eea 0%, #764ba2 100%)","color":"white","padding":"12px 20px","font-size":"15px","font-weight":"500"},
                  class: "rounded-full flex items-center gap-2 hover:opacity-90 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
                }, [
                  _cache[53] || (_cache[53] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "add", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.directT('crm.customers.createCustomer') || 'לקוח חדש'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[54] || (_cache[54] = [
                  _createElementVNode("div", { class: "relative" }, [
                    _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 border-gray-200 dark:border-gray-700" }),
                    _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 border-t-blue-500 animate-spin absolute top-0" })
                  ], -1)
                ])))
              : (_ctx.clients.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "w-24 h-24 rounded-full bg-[#f2f2f7] dark:bg-white/5 flex items-center justify-center mb-4" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[48px] text-[#8e8e93] dark:text-gray-400" }, "group")
                    ], -1)),
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.directT('crm.customers.noCustomers') || 'אין לקוחות'), 1),
                    _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.directT('crm.customers.startByAdding') || 'התחל על ידי הוספת הלקוח הראשון שלך'), 1)
                  ]))
                : (_openBlock(), _createElementBlock("table", _hoisted_35, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_36, [
                        _createElementVNode("th", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "w-4 h-4 rounded border border-gray-300 text-purple-600 focus:ring-1 focus:ring-purple-400 transition-all duration-200",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectAll) = $event)),
                              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.selectAll]
                            ])
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.directT('dashboard.customer') || 'לקוח'), 1),
                        _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.directT('common.email') || 'אימייל'), 1),
                        _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.directT('common.phone') || 'טלפון'), 1),
                        _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.directT('dashboard.crm.source') || 'מקור'), 1),
                        _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.directT('dashboard.crm.action') || 'פעולות'), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedCustomers, (client) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: client.id,
                          class: "bg-white dark:bg-gray-800 border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 group cursor-pointer",
                          onClick: ($event: any) => (_ctx.viewCustomer(client))
                        }, [
                          _createElementVNode("td", {
                            class: "px-3 py-4",
                            style: {"width":"40px","max-width":"40px"},
                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("div", _hoisted_45, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "w-4 h-4 rounded border border-gray-300 text-purple-600 focus:ring-1 focus:ring-purple-400 transition-all duration-200",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCustomers) = $event)),
                                value: client.id
                              }, null, 8, _hoisted_46), [
                                [_vModelCheckbox, _ctx.selectedCustomers]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_47, [
                            _createElementVNode("span", _hoisted_48, _toDisplayString(client.first_name) + " " + _toDisplayString(client.last_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_49, [
                            _createElementVNode("span", _hoisted_50, _toDisplayString(client.email), 1)
                          ]),
                          _createElementVNode("td", _hoisted_51, [
                            _createElementVNode("span", _hoisted_52, _toDisplayString(client.phone), 1)
                          ]),
                          _createElementVNode("td", _hoisted_53, [
                            _createElementVNode("span", _hoisted_54, _toDisplayString(client.source || 'Direct'), 1)
                          ]),
                          _createElementVNode("td", {
                            class: "px-3 py-4 text-center",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "w-6 h-6 rounded-md text-green-600 dark:text-white hover:text-green-700 dark:hover:text-gray-300 hover:bg-green-50 dark:hover:bg-gray-700 transition-all duration-200 flex items-center justify-center",
                                onClick: ($event: any) => (_ctx.editCustomer(client))
                              }, _cache[56] || (_cache[56] = [
                                _createElementVNode("i", { class: "material-symbols-outlined !text-[14px]" }, "edit", -1)
                              ]), 8, _hoisted_56),
                              _createElementVNode("button", {
                                type: "button",
                                class: "w-6 h-6 rounded-md text-red-600 dark:text-white hover:text-red-700 dark:hover:text-gray-300 hover:bg-red-50 dark:hover:bg-gray-700 transition-all duration-200 flex items-center justify-center",
                                onClick: ($event: any) => (_ctx.deleteClient(client.id))
                              }, _cache[57] || (_cache[57] = [
                                _createElementVNode("i", { class: "material-symbols-outlined !text-[14px]" }, "delete", -1)
                              ]), 8, _hoisted_57)
                            ])
                          ])
                        ], 8, _hoisted_44))
                      }), 128))
                    ])
                  ]))
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_Pagination, {
              items: _ctx.itemsPerPage,
              total: _ctx.filteredClients.length,
              "current-page": _ctx.currentPage,
              onPageChange: _ctx.handlePageChange,
              class: "px-6 py-4"
            }, null, 8, ["items", "total", "current-page", "onPageChange"])
          ])
        ])
      ])
    ]),
    (_ctx.showFilterModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeFilterModal && _ctx.closeFilterModal(...args)))
          }),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "w-12 h-12 rounded-2xl bg-gradient-to-br from-[#667eea] to-[#764ba2] flex items-center justify-center shadow-lg" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "filter_list")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_63, _toDisplayString(_ctx.directT('crm.customers.filter') || 'סינון לקוחות'), 1),
                  _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.directT('crm.customers.filterByDifferentCriteria') || 'סנן לקוחות לפי קריטריונים שונים'), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeFilterModal && _ctx.closeFilterModal(...args))),
                class: "w-10 h-10 rounded-full bg-gray-100 dark:bg-white/10 hover:bg-gray-200 dark:hover:bg-white/20 flex items-center justify-center transition-all hover:scale-110 hover:rotate-90"
              }, _cache[59] || (_cache[59] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-[#8e8e93] dark:text-gray-400" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_66, _toDisplayString(_ctx.directT('crm.customers.status') || 'סטטוס'), 1),
                _createElementVNode("div", _hoisted_67, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerStatuses, (status) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: status.id,
                      onClick: ($event: any) => (_ctx.toggleFilter('status', status.statusname)),
                      class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium transition-all", _ctx.filters.status.includes(status.statusname) ? 'bg-blue-500 text-white' : 'bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/20'])
                    }, _toDisplayString(status.statusname), 11, _hoisted_68))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_69, _toDisplayString(_ctx.directT('crm.customers.source') || 'מקור'), 1),
                _createElementVNode("div", _hoisted_70, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerSources, (source) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: source.name,
                      onClick: ($event: any) => (_ctx.toggleFilter('source', source.name)),
                      class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium transition-all", _ctx.filters.source.includes(source.name) ? 'bg-blue-500 text-white' : 'bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/20'])
                    }, _toDisplayString(source.name), 11, _hoisted_71))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clearAllFilters && _ctx.clearAllFilters(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white"
              }, _toDisplayString(_ctx.directT('crm.customers.clearAll') || 'מחק הכל'), 1),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#007AFF] text-white"
              }, _toDisplayString(_ctx.directT('crm.customers.applyFilters') || 'החל סינון'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAddModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _cache[60] || (_cache[60] = _createElementVNode("div", { class: "w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[20px]" }, "person_add")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_78, _toDisplayString(_ctx.directT('crm.customers.modal.title')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "w-8 h-8 rounded-lg flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 transition-all duration-200"
                }, _cache[61] || (_cache[61] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "close", -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.directT('crm.customers.modal.firstName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newCustomer.first_name) = $event)),
                      type: "text",
                      placeholder: _ctx.directT('crm.customers.modal.firstNamePlaceholder'),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm"
                    }, null, 8, _hoisted_83), [
                      [_vModelText, _ctx.newCustomer.first_name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.directT('crm.customers.modal.lastName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newCustomer.last_name) = $event)),
                      type: "text",
                      placeholder: _ctx.directT('crm.customers.modal.lastNamePlaceholder'),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm"
                    }, null, 8, _hoisted_85), [
                      [_vModelText, _ctx.newCustomer.last_name]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.directT('crm.customers.modal.email')), 1),
                  _createElementVNode("div", _hoisted_87, [
                    _cache[62] || (_cache[62] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 !text-[20px]" }, "mail")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newCustomer.email) = $event)),
                      type: "email",
                      placeholder: _ctx.directT('crm.customers.modal.emailPlaceholder'),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white pl-10 pr-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm"
                    }, null, 8, _hoisted_88), [
                      [_vModelText, _ctx.newCustomer.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.directT('crm.customers.modal.phone')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newCustomer.phone) = $event)),
                      type: "tel",
                      placeholder: _ctx.directT('crm.customers.modal.phonePlaceholder'),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm"
                    }, null, 8, _hoisted_91), [
                      [_vModelText, _ctx.newCustomer.phone]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.directT('crm.customers.modal.company')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newCustomer.company) = $event)),
                      type: "text",
                      placeholder: _ctx.directT('crm.customers.modal.companyPlaceholder'),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm"
                    }, null, 8, _hoisted_93), [
                      [_vModelText, _ctx.newCustomer.company]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.directT('crm.customers.modal.source')), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newCustomer.source) = $event)),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white px-4 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all cursor-pointer shadow-sm"
                    }, [
                      _createElementVNode("option", _hoisted_96, _toDisplayString(_ctx.directT('crm.customers.modal.selectSource')), 1),
                      _createElementVNode("option", _hoisted_97, _toDisplayString(_ctx.directT('crm.customers.modal.sources.website')), 1),
                      _createElementVNode("option", _hoisted_98, _toDisplayString(_ctx.directT('crm.customers.modal.sources.socialMedia')), 1),
                      _createElementVNode("option", _hoisted_99, _toDisplayString(_ctx.directT('crm.customers.modal.sources.emailCampaign')), 1),
                      _createElementVNode("option", _hoisted_100, _toDisplayString(_ctx.directT('crm.customers.modal.sources.direct')), 1),
                      _createElementVNode("option", _hoisted_101, _toDisplayString(_ctx.directT('crm.customers.modal.sources.referral')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.newCustomer.source]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.directT('crm.customers.modal.status')), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newCustomer.status) = $event)),
                      class: "w-full h-12 rounded-lg border border-gray-300 bg-white px-4 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all cursor-pointer shadow-sm"
                    }, [
                      _createElementVNode("option", _hoisted_103, _toDisplayString(_ctx.directT('crm.customers.modal.selectStatus')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerStatuses, (status) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: status.id,
                          value: status.statusname
                        }, _toDisplayString(status.statusname), 9, _hoisted_104))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newCustomer.status]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.directT('crm.customers.modal.notes')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newCustomer.notes) = $event)),
                    rows: "4",
                    placeholder: _ctx.directT('crm.customers.modal.notesPlaceholder'),
                    class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all resize-none shadow-sm"
                  }, null, 8, _hoisted_106), [
                    [_vModelText, _ctx.newCustomer.notes]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "px-6 py-3 text-white font-medium rounded-lg transition-all duration-200 hover:opacity-90",
                  style: {"background-color":"#ef4444"}
                }, _toDisplayString(_ctx.directT('crm.customers.modal.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.saveCustomer && _ctx.saveCustomer(...args))),
                  disabled: _ctx.saving,
                  class: "px-6 py-3 text-white font-medium rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 min-w-[100px] justify-center",
                  style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"}
                }, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_110))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.saving ? _ctx.directT('crm.customers.modal.saving') : _ctx.directT('crm.customers.modal.save')), 1)
                ], 8, _hoisted_109)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
          }),
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _cache[63] || (_cache[63] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "ri-delete-bin-line text-white text-2xl" })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_116, _toDisplayString(_ctx.directT('crm.customers.confirmDeletion') || 'Confirm Deletion'), 1),
                    _createElementVNode("p", _hoisted_117, _toDisplayString(_ctx.directT('crm.customers.cannotBeUndone') || 'This action cannot be undone'), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                  class: "w-10 h-10 bg-white/20 hover:bg-white/30 rounded-2xl flex items-center justify-center text-white transition-all duration-200"
                }, _cache[64] || (_cache[64] = [
                  _createElementVNode("i", { class: "ri-close-line text-xl" }, null, -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("p", _hoisted_120, _toDisplayString(_ctx.directT('crm.customers.deleteConfirmation')), 1)
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                  class: "flex-1 px-4 py-3 bg-[#F0F7FF] dark:bg-[#0c1427] text-[#007AFF] dark:text-[#40A9FF] font-medium rounded-2xl transition-all duration-200 hover:bg-[#E6F3FF] dark:hover:bg-[#1a2642] border border-[#007AFF]/20"
                }, _toDisplayString(_ctx.directT('crm.customers.cancel') || 'Cancel'), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                  disabled: _ctx.deleting,
                  class: "flex-1 px-4 py-3 bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#DC2626] hover:to-[#E11D48] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2"
                }, [
                  (_ctx.deleting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_123))
                    : (_openBlock(), _createElementBlock("i", _hoisted_124)),
                  _createTextVNode(" " + _toDisplayString(_ctx.deleting ? _ctx.directT('crm.customers.deleting') : _ctx.directT('crm.customers.deleteCustomer')), 1)
                ], 8, _hoisted_122)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args)))
          }),
          _createElementVNode("div", _hoisted_126, [
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  _cache[65] || (_cache[65] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "ri-user-line text-white text-2xl" })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_130, _toDisplayString(_ctx.directT('crm.customers.customerDetails') || 'Customer Details'), 1),
                    _createElementVNode("p", _hoisted_131, _toDisplayString(_ctx.directT('crm.customers.viewCustomerInformation') || 'View customer information'), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                  class: "w-10 h-10 bg-white/20 hover:bg-white/30 rounded-2xl flex items-center justify-center text-white transition-all duration-200"
                }, _cache[66] || (_cache[66] = [
                  _createElementVNode("i", { class: "ri-close-line text-xl" }, null, -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("h4", _hoisted_135, [
                    _cache[67] || (_cache[67] = _createElementVNode("i", { class: "ri-user-line text-[#007AFF] mr-3 text-2xl" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.customers.personalInformation') || 'Personal Information'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_137, _toDisplayString(_ctx.directT('crm.customers.fullName')), 1),
                      _createElementVNode("p", _hoisted_138, _toDisplayString(_ctx.selectedCustomer?.first_name) + " " + _toDisplayString(_ctx.selectedCustomer?.last_name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_139, _toDisplayString(_ctx.directT('crm.customers.email')), 1),
                      _createElementVNode("p", _hoisted_140, _toDisplayString(_ctx.selectedCustomer?.email || 'N/A'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_141, _toDisplayString(_ctx.directT('crm.customers.phone')), 1),
                      _createElementVNode("p", _hoisted_142, _toDisplayString(_ctx.selectedCustomer?.phone || 'N/A'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_143, _toDisplayString(_ctx.directT('crm.customers.status')), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-3 py-1 rounded-xl font-medium text-sm", _ctx.getStatusClass(_ctx.selectedCustomer?.status)])
                      }, _toDisplayString(_ctx.selectedCustomer?.status), 3)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_144, [
                  _createElementVNode("h4", _hoisted_145, [
                    _cache[68] || (_cache[68] = _createElementVNode("i", { class: "ri-map-pin-line text-[#34C759] mr-3 text-2xl" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.customers.addressAndBusiness') || 'Address & Business'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_147, _toDisplayString(_ctx.directT('crm.customers.address')), 1),
                      _createElementVNode("p", _hoisted_148, _toDisplayString(_ctx.selectedCustomer?.address || 'N/A'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_150, _toDisplayString(_ctx.directT('crm.customers.city')), 1),
                        _createElementVNode("p", _hoisted_151, _toDisplayString(_ctx.selectedCustomer?.city || 'N/A'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_152, _toDisplayString(_ctx.directT('crm.customers.country')), 1),
                        _createElementVNode("p", _hoisted_153, _toDisplayString(_ctx.selectedCustomer?.country || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_154, _toDisplayString(_ctx.directT('crm.customers.receivedAmount')), 1),
                      _createElementVNode("p", _hoisted_155, _toDisplayString(_ctx.formatCurrency(_ctx.selectedCustomer?.received)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_156, _toDisplayString(_ctx.directT('crm.customers.source')), 1),
                      _createElementVNode("p", _hoisted_157, _toDisplayString(_ctx.selectedCustomer?.shopify_id ? _ctx.directT('crm.customers.shopify') : 
                 _ctx.selectedCustomer?.woocommerce_id ? _ctx.directT('crm.customers.wooCommerce') : 
                 _ctx.directT('crm.customers.manual')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                  class: "px-6 py-3 bg-[#F0F7FF] dark:bg-[#0c1427] text-[#007AFF] dark:text-[#40A9FF] font-medium rounded-2xl transition-all duration-200 hover:bg-[#E6F3FF] dark:hover:bg-[#1a2642] border border-[#007AFF]/20"
                }, _toDisplayString(_ctx.directT('crm.customers.close') || 'Close'), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
          }),
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("div", _hoisted_164, [
                  _cache[69] || (_cache[69] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "ri-edit-line text-white text-2xl" })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_165, _toDisplayString(_ctx.directT('crm.customers.editCustomer') || 'Edit Customer'), 1),
                    _createElementVNode("p", _hoisted_166, _toDisplayString(_ctx.directT('crm.customers.updateCustomerInformation') || 'Update customer information'), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                  class: "w-10 h-10 bg-white/20 hover:bg-white/30 rounded-2xl flex items-center justify-center text-white transition-all duration-200"
                }, _cache[70] || (_cache[70] = [
                  _createElementVNode("i", { class: "ri-close-line text-xl" }, null, -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_167, [
              _createElementVNode("div", _hoisted_168, [
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("h4", _hoisted_170, [
                    _cache[71] || (_cache[71] = _createElementVNode("i", { class: "ri-user-line text-[#007AFF] mr-3 text-2xl" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.customers.personalInformation') || 'Personal Information'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", null, [
                      _cache[72] || (_cache[72] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, [
                        _createTextVNode(" First Name "),
                        _createElementVNode("span", { class: "text-[#FF3B30]" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.editingCustomer.first_name) = $event)),
                        type: "text",
                        required: "",
                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#007AFF] focus:ring-4 focus:ring-[#007AFF]/10",
                        placeholder: "Enter first name"
                      }, null, 512), [
                        [_vModelText, _ctx.editingCustomer.first_name]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[73] || (_cache[73] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, [
                        _createTextVNode(" Last Name "),
                        _createElementVNode("span", { class: "text-[#FF3B30]" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editingCustomer.last_name) = $event)),
                        type: "text",
                        required: "",
                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#007AFF] focus:ring-4 focus:ring-[#007AFF]/10",
                        placeholder: "Enter last name"
                      }, null, 512), [
                        [_vModelText, _ctx.editingCustomer.last_name]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_172, [
                  _cache[76] || (_cache[76] = _createElementVNode("h4", { class: "text-xl font-bold text-[#1a1a1a] dark:text-white mb-6 flex items-center" }, [
                    _createElementVNode("i", { class: "ri-phone-line text-[#34C759] mr-3 text-2xl" }),
                    _createTextVNode(" Contact Information ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", null, [
                      _cache[74] || (_cache[74] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, [
                        _createTextVNode(" Email Address "),
                        _createElementVNode("span", { class: "text-[#FF3B30]" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.editingCustomer.email) = $event)),
                        type: "email",
                        required: "",
                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#34C759] focus:ring-4 focus:ring-[#34C759]/10",
                        placeholder: "customer@example.com"
                      }, null, 512), [
                        [_vModelText, _ctx.editingCustomer.email]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[75] || (_cache[75] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, " Phone Number ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.editingCustomer.phone) = $event)),
                        type: "tel",
                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#34C759] focus:ring-4 focus:ring-[#34C759]/10",
                        placeholder: "+972-50-123-4567"
                      }, null, 512), [
                        [_vModelText, _ctx.editingCustomer.phone]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_174, [
                  _cache[81] || (_cache[81] = _createElementVNode("h4", { class: "text-xl font-bold text-[#1a1a1a] dark:text-white mb-6 flex items-center" }, [
                    _createElementVNode("i", { class: "ri-building-line text-[#5856D6] mr-3 text-2xl" }),
                    _createTextVNode(" Business Information ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_175, [
                    _createElementVNode("div", null, [
                      _cache[78] || (_cache[78] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, " Customer Status ", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.editingCustomer.status) = $event)),
                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none cursor-pointer transition-all focus:border-[#5856D6] focus:ring-4 focus:ring-[#5856D6]/10"
                      }, _cache[77] || (_cache[77] = [
                        _createElementVNode("option", { value: "New" }, "New Customer", -1),
                        _createElementVNode("option", { value: "Active" }, "Active Customer", -1),
                        _createElementVNode("option", { value: "Inactive" }, "Inactive Customer", -1),
                        _createElementVNode("option", { value: "Pending" }, "Pending Approval", -1)
                      ]), 512), [
                        [_vModelSelect, _ctx.editingCustomer.status]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[80] || (_cache[80] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, " Total Revenue ", -1)),
                      _createElementVNode("div", _hoisted_176, [
                        _cache[79] || (_cache[79] = _createElementVNode("span", { class: "absolute left-4 top-1/2 -translate-y-1/2 text-[#5856D6] font-bold" }, "₪", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.editingCustomer.received) = $event)),
                          type: "number",
                          min: "0",
                          step: "0.01",
                          class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] pl-10 pr-4 outline-none transition-all focus:border-[#5856D6] focus:ring-4 focus:ring-[#5856D6]/10",
                          placeholder: "0.00"
                        }, null, 512), [
                          [_vModelText, _ctx.editingCustomer.received]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_177, [
                  _createElementVNode("h4", _hoisted_178, [
                    _cache[82] || (_cache[82] = _createElementVNode("i", { class: "ri-map-pin-line text-[#FF9500] mr-3 text-2xl" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.customers.addressInformation') || 'Address Information'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_179, [
                    _createElementVNode("div", null, [
                      _cache[83] || (_cache[83] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, " Street Address ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.editingCustomer.address) = $event)),
                        type: "text",
                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10",
                        placeholder: "רחוב דיזנגוף 123, תל אביב"
                      }, null, 512), [
                        [_vModelText, _ctx.editingCustomer.address]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_180, [
                      _createElementVNode("div", null, [
                        _cache[84] || (_cache[84] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, " City ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.editingCustomer.city) = $event)),
                          type: "text",
                          class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10",
                          placeholder: "Tel Aviv"
                        }, null, 512), [
                          [_vModelText, _ctx.editingCustomer.city]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[85] || (_cache[85] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#666666] dark:text-[#cccccc] mb-2" }, " Country ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.editingCustomer.country) = $event)),
                          type: "text",
                          class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10",
                          placeholder: "Israel"
                        }, null, 512), [
                          [_vModelText, _ctx.editingCustomer.country]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_181, [
              _createElementVNode("div", _hoisted_182, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                  class: "px-6 py-3 bg-[#F0F7FF] dark:bg-[#0c1427] text-[#007AFF] dark:text-[#40A9FF] font-medium rounded-2xl transition-all duration-200 hover:bg-[#E6F3FF] dark:hover:bg-[#1a2642] border border-[#007AFF]/20"
                }, _toDisplayString(_ctx.directT('crm.customers.cancel') || 'Cancel'), 1),
                _createElementVNode("button", {
                  onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args))),
                  disabled: _ctx.saving,
                  class: "px-6 py-3 bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#0056CC] hover:to-[#4338CA] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex items-center gap-2 min-w-[140px] justify-center"
                }, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_184))
                    : (_openBlock(), _createElementBlock("i", _hoisted_185)),
                  _createTextVNode(" " + _toDisplayString(_ctx.saving ? (_ctx.directT('crm.customers.updating') || 'Updating...') : (_ctx.directT('crm.customers.updateCustomer') || 'Update Customer')), 1)
                ], 8, _hoisted_183)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}